import { doHttp, doHttp2 } from '../utils/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../utils/config'

/**
 * 新增/编辑 标签
 * @param params
 * @param companyId
 * @return {*}
 */
export function apiLabelEdit (params, companyId) {
  return doHttp(`/label/label/addOrUpdate.action?companyId=${companyId}`, HTTP_TYPE_POST, params)
}

/**
 * 删除
 * @param id
 * @return {*}
 */
export function apiDelete (id) {
  let params = {
    id,
    flag: 2 // 1:禁用/启用 2:删除
  }
  return doHttp('/label/label/delete.action', HTTP_TYPE_GET, params)
}

/**
 * 禁用/启用
 * @param id
 * @return {*}
 */
export function apiSwitch (id) {
  let params = {
    id,
    flag: 1 // 1:禁用/启用 2:删除
  }
  return doHttp('/label/label/delete.action', HTTP_TYPE_GET, params)
}

/**
 * 详情
 * @param id
 * @return {*}
 */
export function apiDetail (id) {
  let params = { id }
  return doHttp('/label/label/detail.action', HTTP_TYPE_GET, params)
}

/**
 * 标签列表
 * @param params
 * @param flag
 * @param status 0:未禁用 1:已禁用
 * @param pageIndex
 * @param pageSize
 * @return {*}
 */
export function apiLabelList (flag, status, params, pageIndex = 1, pageSize = 20) {
  return doHttp(`/label/label/list.action?flag=${flag}&status=${status}&pageIndex=${pageIndex}&pageSize=${pageSize}`, HTTP_TYPE_POST, params)
}

/**
 * 新增/编辑 批次
 * @param params
 * @return {*}
 */
export function apiLabelPrintEdit (params, flag = 1) {
  return doHttp(`/label/labelPrint/addOrUpdate.action?flag=${flag}`, HTTP_TYPE_POST, params)
}

/**
 * 批次列表
 * @param params
 * @param type 1:普通 2:营销
 * @param flag 1:正常 2:历史打印数据
 * @param pageIndex
 * @param pageSize
 * @return {*}
 */
export function apiLabelPrintList (params, type, flag, pageIndex = 1, pageSize = 20) {
  return doHttp(`/label/labelPrint/list.action?type=${type}&flag=${flag}&pageIndex=${pageIndex}&pageSize=${pageSize}`, HTTP_TYPE_POST, params)
}

/**
 * 复用
 * @param from 源表
 * @param to 新建表
 * @return {*}
 */
export function apiCopyLabel (from, to) {
  let params = {
    how: 'copy',
    from,
    to
  }
  return doHttp2('/printer/service/reportService.jsp', HTTP_TYPE_GET, params)
}

/**
 * 获取pid
 * @param token
 * @param tid 表名
 * @param dataset 数据源
 * @return {*}
 */
export function apiGetPid (token, tid, dataset) {
  let params = {
    method: 'openTemplate',
    token,
    tid,
    dataset
  }
  return doHttp2('/printer/api', HTTP_TYPE_POST, params)
}

/**
 * 预览
 * @param tid 表名
 * @param pid 数据源
 * @return {*}
 */
export function apiBuildPage (tid, pid) {
  let params = {
    tid,
    pid
  }
  return doHttp2('/printer/service/buildPage.jsp', HTTP_TYPE_GET, params)
}

/**
 * 标签模板列表
 * @param pageIndex
 * @param pageSize
 * @return {*}
 */
export function apiLabelModuleList (companyId, query) {
  let params = {
    companyId,
    query
  }
  return doHttp('/label/labelModule/list.action', HTTP_TYPE_GET, params)
}
